import renderColorButton from "./renderColorButton";
export var kerning = {
  label: 'Кернинг',
  property: 'kerning',
  initial: 'small',
  options: [{
    label: 'Маленький',
    value: 'small'
  }, {
    label: 'Средний',
    value: 'average'
  }, {
    label: 'Большой',
    value: 'large'
  }]
};
export var fontSize = {
  label: 'Размер шрифта',
  property: 'fontsize',
  initial: 'small',
  options: [{
    label: 'Маленький',
    value: 'small'
  }, {
    label: 'Средний',
    value: 'average'
  }, {
    label: 'Большой',
    value: 'large'
  }]
};
export var images = {
  label: 'Изображения',
  property: 'images',
  initial: 'on',
  options: [{
    label: 'Вкл',
    value: 'on'
  }, {
    label: 'Выкл',
    value: 'off'
  }]
};
export var color = {
  label: 'Цвет',
  property: 'color',
  initial: 'white',
  renderButton: renderColorButton,
  options: [{
    label: 'Б',
    value: 'white'
  }, {
    label: 'Ч',
    value: 'black'
  }, {
    label: 'Г',
    value: 'blue'
  }]
};
var defaultGroups = [kerning, fontSize, images, color];
export default defaultGroups;